export default __webpack_public_path__ + "static/media/GR6 2A-2C-2D-2EC.ffc92ec4.jpg";